import * as Yup from 'yup'

const formValidationSchema = {
  entity: Yup.string().required('请选择公司'),
  name: Yup.string().required('请输入姓名'),
  role: Yup.array().min(1, '请选择职务'),
}

export default formValidationSchema
